<script>
	import { cn } from "./cn.js";
	import Badge from "./Badge.svelte";

	// shadcn 카드형 섹션: 헤더(제목 + 설명 + 필수/선택 배지) + 본문.
	// muted 캔버스 위에 얹혀 "관리자 콘솔" 느낌을 만든다.
	export let title = "";
	export let description = "";
	export let required = false;
	export let optional = false;
	let className = "";
	export { className as class };
</script>

<section
	class={cn(
		"tw-rounded-xl tw-border tw-border-border tw-bg-card tw-shadow-sm",
		className,
	)}
>
	{#if title}
		<div class="tw-flex tw-items-start tw-justify-between tw-gap-2 tw-border-b tw-border-border tw-px-5 tw-py-4">
			<div class="tw-min-w-0">
				<div class="tw-flex tw-items-center tw-gap-2">
					<h3 class="tw-text-sm tw-font-semibold tw-text-foreground">{title}</h3>
					{#if required}<Badge variant="required">필수</Badge>{/if}
					{#if optional}<Badge variant="optional">선택</Badge>{/if}
				</div>
				{#if description}
					<p class="tw-mt-1 tw-text-xs tw-text-muted-foreground">{description}</p>
				{/if}
			</div>
			<slot name="badge" />
		</div>
	{/if}
	<div class="tw-px-5 tw-py-5">
		<slot />
	</div>
</section>
